import React, { useState, useEffect } from 'react'

import { useAppContext } from 'AppContext'

const MistakeButton = ({ onDelete }) => {
    const [pressed, setPressed] = useState(false)
    const [loading, setLoading] = useState(false)

    const { setPopupOpen } = useAppContext()

    const onFirstClick = () => {
        setPressed(true)
    }

    const onConfirm = () => {
        setLoading(true)
        setTimeout(() => setPopupOpen(false), 3000)
    }

    if (loading) {
        return (
            <button className={`animate-pulse bg-red-800 hover:bg-red-800 transition flex text-white font-semibold py-2 px-4 rounded shadow`}
                onClick={pressed ? onConfirm : onFirstClick}
            >
                Loading
            </button>
        )
    }

    return (
        <button class={`${pressed ? 'bg-red-800' : 'bg-red-600'} hover:bg-red-800 transition flex text-white font-semibold py-2 px-4 rounded shadow`}
            onClick={pressed ? onConfirm : onFirstClick}
        >
            { pressed ? 'Confirm' : 'Report Mistake' }
        </button>
    )
}

export default MistakeButton